import { render, staticRenderFns } from "./Schematrons.vue?vue&type=template&id=e9a4ec66&"
import script from "./Schematrons.vue?vue&type=script&lang=js&"
export * from "./Schematrons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports